"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteBillingCronResponse = exports.WaysteBillingCronRequest = exports.BillingDetailsUpdate = exports.BillingDetailsCreate = exports.BillingDetailsQuery = exports.BillingDetailsTransport = exports.BillingDetails = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const collection_relation_update_1 = require("../../common/collection-relation-update");
const CommercialLineItem_1 = require("./CommercialLineItem");
const billing_details_shared_1 = require("./billing-details-shared");
exports.BillingDetails = typebox_1.Type.Intersect([
    billing_details_shared_1.BillingDetailsSharedFields,
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Array(CommercialLineItem_1.CommercialLineItemTransport),
    }),
]);
exports.BillingDetailsTransport = typebox_1.Type.Intersect([
    billing_details_shared_1.BillingDetailsSharedFields,
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Array(CommercialLineItem_1.CommercialLineItemTransport),
    }),
]);
exports.BillingDetailsQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([common_1.BaseQuery, billing_details_shared_1.BillingDetailsSharedQuery]));
exports.BillingDetailsCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(billing_details_shared_1.BillingDetailsSharedCreateFields, [
        'id',
        'haulerID',
        'customerID',
        'subscriptionID',
        'lineItems',
        'metadata',
    ]),
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Array(CommercialLineItem_1.CommercialLineItemNestedCreate),
    }),
]);
exports.BillingDetailsUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(billing_details_shared_1.BillingDetailsSharedUpdateFields, [
        'id',
        'haulerID',
        'customerID',
        'subscriptionID',
        'lineItems',
        'metadata',
        'paymentMethod',
    ]),
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(CommercialLineItem_1.CommercialLineItemNestedCreate, CommercialLineItem_1.CommercialLineItemUpdate, typebox_1.Type.String({ format: 'uuid' }))),
        paymentMethod: (0, common_1.Nullable)(common_1.PaymentMethod),
    }),
]));
exports.WaysteBillingCronRequest = typebox_1.Type.Optional(typebox_1.Type.Partial(typebox_1.Type.Object({
    billingIdsToProcess: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    date: typebox_1.Type.String({ format: 'date' }),
})));
exports.WaysteBillingCronResponse = typebox_1.Type.Object({
    billingActivityIdsCreated: typebox_1.Type.Array(typebox_1.Type.String()),
});
//# sourceMappingURL=BillingDetails.js.map